import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/modern/components/ui/alert-dialog";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  busy?: boolean;
  onConfirm: () => void | Promise<void>;
};

/** Confirm reanalyze-all-pending — leaves accepted / rejected / skipped alone. */
export default function PromoteSurfaceReanalyzeDialog({
  open,
  onOpenChange,
  busy,
  onConfirm,
}: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Reanalyze all pending drafts?</AlertDialogTitle>
          <AlertDialogDescription>
            This deletes every pending Review draft on the board and asks AI to regenerate them.
            Accepted, Rejected, and Skip items are left alone. Large boards may take a while —
            keep this tab open and watch the queue refill.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={busy}
            onClick={(event) => {
              event.preventDefault();
              void onConfirm();
            }}
          >
            {busy ? "Starting…" : "Reanalyze pending"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
